import React from 'react';
import styled from 'styled-components';
const _HighWord = styled.span`
  color: ${props => props.color};
`;

interface HighWordProps {
  content: string;
  word: string;
  color?: string;
}

export function HighWord({ content, word, color = '#FFB21E' }: HighWordProps) {
  const reg = new RegExp(word, 'ig');
  const filledArr: string[] = content.match(reg) || [];

  const splitedStrArr = filledArr.reduce(
    (arr: any[], item: string, index: number): any[] => {
      const start: number = content.indexOf(item);
      const len: number = item.length;
      arr.push(<span key={'span' + index}>{content.slice(0, start)}</span>);
      arr.push(
        <_HighWord key={'highword' + index} color={color}>
          {item}
        </_HighWord>
      );
      content = content.slice(start + len);
      return arr;
    },
    []
  );
  splitedStrArr.push(<span key="span_last">{content}</span>);

  return <span>{splitedStrArr}</span>;
}
